import { render, staticRenderFns } from "./header.creator-payments.vue?vue&type=template&id=6bb4878a&scoped=true&"
import script from "./header.creator-payments.vue?vue&type=script&lang=js&"
export * from "./header.creator-payments.vue?vue&type=script&lang=js&"
import style0 from "./header.creator-payments.vue?vue&type=style&index=0&id=6bb4878a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb4878a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
